<template>
  <div class="related-series" v-if="pageItems.length">
    <strong class="cxStrong">
        <a :href="titleUrl" target="_blank" @click="countAd(4238)"><em>{{$global.q}}</em>【相关车系】</a>
    </strong>
    <div class="hotcarbox">
      <el-carousel :height="carouselHeight" :autoplay="false" :indicator-position="isShowIndicator" :arrow="isShowToggle">
        <el-carousel-item v-for="(page, count) in pageItems" :key="count">
          <ul>
            <li v-for="(item,index) in page.items" :key="index">
              <i class="label" :class="[count === 0 && index < 3 ? 'label-orange' : 'label-blue']">{{(count * pageSize) + index + 1}}</i>
              <div class="pic" @click="toSeriesInfo(item.url)">
                <img width="120" height="90" alt="" :src="item.image || defaultSeriesImage">
                <div class="car-tag" :class="{'orange': item.carTag === '将上市'}" v-if="item.carTag">{{item.carTag}}</div>
              </div>
              <div class="tit blue" @click="toSeriesPriceInfo(item.url)">{{item.name}}</div>
              <div class="price red" @click="toSeriesPriceInfo(item.url)">{{item.price || '暂无报价'}}</div>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RelatedSeries',
    props: {
      list: {
        type:Array,
        default: () => ([])
      }
    },
    data() {
      return {
        totalHeight: 350,
        pageSize: 8,
        columns: 4,
        defaultSeriesImage: 'https://www1.pcauto.com.cn/zt/new-kuai-sou/app/images/icon-car-photo-default.png'
      }
    },
    computed: {
      titleUrl() {
        return 'https://price.pcauto.com.cn/cars/'
      },
      // 滑动卡片高度
      carouselHeight() {
        const rows = Math.ceil(this.pageSize / this.columns)
        const singleRowHeight = parseFloat(this.totalHeight / rows).toFixed(2)
        const curRow = Math.ceil(this.list.length / this.columns)
        if (curRow < rows) {
          return `${singleRowHeight * curRow}px`
        } else {
          return `${this.totalHeight}px`
        }
      },
      // 是否显示指示器
      isShowIndicator() {
        if (this.pageItems.length > 1) {
          return ''
        } else {
          return 'none'
        }
      },
      // 是否显示切换
      isShowToggle() {
        if (this.pageItems.length > 1) {
          return 'hover'
        } else {
          return 'never'
        }
      },
      pageItems() {
        const totalItems = this.list
        const total = totalItems.length
        const pageCount = Math.ceil(total / this.pageSize)
        let pageItems = Array(pageCount).fill()
        pageItems = pageItems.map((m, n) => {
          let startIndex = n * this.pageSize
          let endIndex = startIndex + this.pageSize
          if (n === pageCount - 1) {
            endIndex = total
          }
          return {
            items: totalItems.slice(startIndex, endIndex)
          }
        })
        return pageItems
      }
    },
    methods: {
      // 查看车系
      toSeriesInfo(url) {
        const seriesId = url.replace(/pcautobrowser:\/\/serial\/(.*?)/g, '')
        window.open(`https://price.pcauto.com.cn/sg${seriesId}/`)
      },
      toSeriesPriceInfo(url) {
        const seriesId = url.replace(/pcautobrowser:\/\/serial\/(.*?)/g, '')
        window.open(`https://price.pcauto.com.cn/sg${seriesId}/price.html`)
      }
    }
  }
</script>

<style lang="scss" scoped>
.related-series {
    margin-bottom: 25px;
    .cxStrong {
        font-weight: normal;
        font-size: 16px;
        line-height: 36px;
        display: inline-block;
        a {
            cursor: pointer;
            text-decoration: underline;
            color: #225599;            
        }
        em {
            color: #cc0000;
            text-decoration: underline;
            font-style: normal;
        }
    }
    .hotcarbox {
        width: 640px;
        &::v-deep .el-carousel__indicator button {
            background: #BFC3C8;
            width: 7px;
            height: 7px;
            border-radius: 50%;
        }
        &::v-deep .el-carousel__indicator.is-active button {
            width: 30px;
            border-radius: 20px;
            background: #0E60D5;
        }
        
        ul {
            margin-right: -50px;
            position: relative;
            zoom: 1; 
            display: flex;
            flex-wrap: wrap;
            li {
                margin-right: 46px;
                width: 120px;
                height: 164px;
                position: relative; 
                .pic {
                    position: relative;
                    display: block;
                    &:hover {
                      cursor: pointer;
                    }
                    img {
                        border: 0;
                        vertical-align: middle; 
                        object-fit: contain;  
                    }
                    .car-tag {
                        position: absolute;
                        width: 15px;
                        left: 120px;
                        top: 0px;
                        background-position: -51px -30px;
                        color: #fff;
                        text-align: center;
                        background: #BD0005;
                    }
                    .orange {
                      background: #FDA553;
                    }
                } 
                .tit {
                    font-size: 14px;
                    font-weight: bold;
                    display: block;
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    height: 26px;
                    line-height: 26px;
                    margin-top: 2px;      
                    color: #225599;
                    &:hover {
                      cursor: pointer;
                      color: #FDA553;
                    }              
                }
                .price {
                    display: block;
                    text-align: center;  
                    color: #cc0000;
                    &:hover {
                      cursor: pointer;
                      color: #FDA553;
                    }                 
                }
                .label {
                    position: absolute;
                    width: 24px;
                    height: 13px;
                    line-height: 12px;
                    color: #fff;
                    font-style: normal;
                    text-align: center;
                    font-weight: bold;
                    background: url($imageURL) no-repeat;
                    z-index: 1;
                }
                .label-orange {
                    background-position: -35px -81px;
                }
                .label-blue {
                    background-position: -60px -81px;
                }              
            }           
        }
    }  
    .hotcarmore  {
        position: relative;
        .blue {
            color: #225599!important;
            text-decoration: underline;
        }        
    }
}
</style>